import React from 'react';
import { Card, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { ShoppingCartItemProps } from '../interfaces';
import CartItemImage from '../cartItemImage/';
import ImgFV from '../../assets/img/ImgFV.jpg';
import ShoppingCartItemDetails from './ShoppingCartItemDetails';
import ShoppingCartRemoveModal from './ShoppingCartRemoveModal';
import { useShoppingCartItem } from './useShoppingCartItem';
import './shoppingCartItem.scss';

const ShoppingCartItem: React.FC<ShoppingCartItemProps> = ({ item }) => {
  const {
    isRemoveModalOpen,
    itemPrice,
    materialDataLoading,
    selectedMaterial,
    selectedSize,
    stockQuantity,
    validationIssue,
    handleDeleteItem,
    handleDecrementQuantity,
    handleImageClick,
    handleIncrementQuantity,
    setIsRemoveModalOpen,
  } = useShoppingCartItem(item);

  return (
    <Card hoverable className="cart-item">
      <ShoppingCartRemoveModal
        open={isRemoveModalOpen}
        productTitle={item.product.title}
        onConfirm={handleDeleteItem}
        onCancel={() => setIsRemoveModalOpen(false)}
      />
      <Button
        className="cart-delete-button"
        icon={<DeleteOutlined />}
        aria-label={`Remove ${item.product.title}`}
        onClick={handleDeleteItem}
      />
      <CartItemImage
        itemId={item.id}
        defaultSrc={ImgFV}
        alt={item.product.title}
        onClick={handleImageClick}
      />
      <ShoppingCartItemDetails
        item={item}
        itemPrice={itemPrice}
        materialDataLoading={materialDataLoading}
        selectedMaterial={selectedMaterial}
        selectedSize={selectedSize}
        stockQuantity={stockQuantity}
        validationMessage={validationIssue?.message}
        onDecrementQuantity={handleDecrementQuantity}
        onIncrementQuantity={handleIncrementQuantity}
      />
    </Card>
  );
};

export default ShoppingCartItem;
